module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/life_coop-a0141b9eb916e0278a3247d026a8ff8f.gif";